import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { GeneralRegistrationFormView } from './general-registration-form.presentation';
import GeneralRegistrationFormVM from './general-registration-form.viewmodel';

export interface IGeneralRegistrationContainerProps {
    accountId: number;
    eventId: number;
    subdomain: string;
    registrationEnabled: boolean;
    toggleAttendeeRegistrationWebsiteForm: (registrationEnabled: boolean) => void;
    showFormRegistrationFormPopup: () => void;
    registrationAsLandingPage: boolean;
    toggleRegistrationAsLandingWebsiteForm: (registrationAsLandingPage: boolean) => void;
    closeConfigureRegistrationForm: () => void;
    registrationApprovalEnabled: boolean;
    urlParameterRegistrationEnabled: boolean;
}

const GeneralRegistrationFormContainer = withViewModel(GeneralRegistrationFormView,
    async (props: IGeneralRegistrationContainerProps) => {
    const {
        accountId,
        eventId,
        registrationEnabled,
        registrationApprovalEnabled,
        urlParameterRegistrationEnabled,
        toggleAttendeeRegistrationWebsiteForm,
        subdomain,
        showFormRegistrationFormPopup,
        registrationAsLandingPage,
        toggleRegistrationAsLandingWebsiteForm,
        closeConfigureRegistrationForm,
     } = props;
    const generalRegistrationVM = new GeneralRegistrationFormVM(
        accountId,
        eventId,
        subdomain,
        registrationEnabled,
        registrationApprovalEnabled,
        urlParameterRegistrationEnabled,
        toggleAttendeeRegistrationWebsiteForm,
        showFormRegistrationFormPopup,
        registrationAsLandingPage,
        toggleRegistrationAsLandingWebsiteForm,
        closeConfigureRegistrationForm,
    );

    generalRegistrationVM.initialize();

    return generalRegistrationVM;
});

export { GeneralRegistrationFormContainer as GeneralRegistrationForm };